"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = [{
  name: '稿定设计',
  href: 'https://www.gaoding.com'
}, {
  name: '优设网',
  href: 'https://www.uisdc.com/'
}, {
  name: '优优教程网',
  href: 'https://uiiiuiii.com/'
}, {
  name: '微信编辑器',
  href: 'http://www.xmyeditor.com/'
}, {
  name: '365编辑器',
  href: 'http://www.365editor.com/'
}, {
  name: '3分钟排版',
  href: 'http://www.135editor.com/'
}, {
  name: '恶搞P图',
  href: 'http://vpeitu.com/'
}, {
  name: 'H5页面制作',
  href: 'https://www.rrxiu.net/'
}, {
  name: '新媒体运营',
  href: 'https://www.bpteach.com'
}, {
  name: '亿卓智库',
  href: 'http://www.izcoo.com'
}, {
  name: '设计之家',
  href: 'http://www.sj33.cn'
}, {
  name: '墨刀原型设计',
  href: 'https://modao.cc/?utm_source=gdsj '
}];
exports.default = _default;